import { AppBar, Drawer, Grid, IconButton, InputBase, Tab, Tabs } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';

import { Row, Rows } from '~/src/dash/components/layout';
import { MakeTabProps, TabPanel } from '~/src/dash/components/TabPanel';
import { backgroundColor } from '~/src/dash/utils/material-dashboard-react';
import { ButtonView } from '~/src/dash/views/button-view';

export interface ILiveLogsTabWrapper {
  title: string;
  render: (searchFilter: string) => React.ReactElement;
}

interface IProps {
  elements: ILiveLogsTabWrapper[];
  openLiveLogs: boolean;
  onClose: () => void;
  getLiveLogs: () => void;
  classes: any;
  refreshingLiveLogs: boolean;
  refreshingLiveLogsTimestamp: string;
}

// Popup which show the live logs
export function LiveLogsPopup(props: IProps) {
  const [activeTabIDX, setActiveTabIDX] = useState(0);
  const [liveLogFilter, setLiveLogFilter] = useState('');

  return (
    <Drawer
      anchor='right'
      open={props.openLiveLogs}
      onClose={() => props.onClose()}
      classes={props.classes}
      style={{
        maxWidth: '800px',
      }}
    >
      <Grid
        container
        direction='row'
        justify='flex-start'
        alignItems='center'
        style={{
          paddingLeft: '20px',
          width: '100%',
        }}
      >
        <Grid item style={{ paddingRight: '20px' }}>
          <h1>Live Logs</h1>
        </Grid>
        <Grid item>
          <ButtonView
            onClick={() => props.getLiveLogs(false)}
            text='Refresh'
            active={props.refreshingLiveLogs}
          />
        </Grid>
        {props.refreshingLiveLogsTimestamp && (
          <Grid item style={{ paddingLeft: '10px' }}>
            {`Last Updated At ${props.refreshingLiveLogsTimestamp}`}
          </Grid>
        )}
      </Grid>

      <div
        style={{
          backgroundColor: '#F8F8F8',
          display: 'inline-block',
          marginBottom: '10px',
          minWidth: 350,
          width: '100%',
        }}
      >
        <IconButton classes={{ root: props.classes.iconButton }}>
          <SearchIcon />
        </IconButton>
        <InputBase
          style={{ width: 'calc(100% - 3em' }}
          placeholder='search by keyword or value'
          value={liveLogFilter}
          onChange={(event) => setLiveLogFilter(event.target.value)}
        />
      </div>
      <AppBar
        position='static'
        style={{
          backgroundColor,
          boxShadow: 'none',
          color: 'black',
        }}
      >
        <Tabs
          value={activeTabIDX}
          onChange={(_: any, newIndex: number) => {
            setActiveTabIDX(newIndex);
            setLiveLogFilter('');
          }}
          aria-label='simple tabs'
        >
          {props.elements.map((value: ILiveLogsTabWrapper, idx: number) => {
            return <Tab label={value.title} {...MakeTabProps({ idx })} />;
          })}
        </Tabs>
      </AppBar>
      <Rows style={{ width: '800px' }}>
        {props.elements.map((value: ILiveLogsTabWrapper, idx: number) => {
          return (
            <Row>
              <TabPanel value={activeTabIDX} index={idx}>
                {value.render(liveLogFilter)}
              </TabPanel>
            </Row>
          );
        })}
      </Rows>
    </Drawer>
  );
}
